module.exports = require("./fr-CH.d.ts");